import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import NiceModal from '@ebay/nice-modal-react'
import BookLsMeetingModal from './components/BookLsMeetingModal'

const BookLsMeeting = ({ readOnly, task, order, refetch }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    NiceModal.show(BookLsMeetingModal, { task, order })
      .then(refetch)
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <Menu.Item key='BookLsMeeting' disabled={readOnly || (typeof task.supplier !== 'object')}>
      {(props) => (
        <MenuButton disabled={readOnly || (typeof task.supplier !== 'object')} {...props} onClick={onClick}>
          { formatMessage(messages.bookMeeting) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default BookLsMeeting